var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "testControl" }, [
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.XZJG"))),
        ]),
        _c(
          "span",
          [
            _c(
              "el-select",
              {
                attrs: {
                  size: "small",
                  filterable: "",
                  placeholder: _vm.$t("testControl.QXZJG"),
                },
                on: {
                  change: () => {
                    _vm.clearData("subminPaperData", "planId")
                    _vm.clearData("subminPaperData", "teamOrPlayer")
                    _vm.getPlanList(
                      "getSubminPaperData",
                      _vm.subminPaperData.orgId
                    )
                  },
                },
                model: {
                  value: _vm.subminPaperData.orgId,
                  callback: function ($$v) {
                    _vm.$set(_vm.subminPaperData, "orgId", $$v)
                  },
                  expression: "subminPaperData.orgId",
                },
              },
              _vm._l(_vm.orgList, function (item) {
                return _c("el-option", {
                  key: item.orgId,
                  attrs: { label: item.orgName, value: item.orgId },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.LXJH"))),
        ]),
        _c(
          "span",
          [
            _c(
              "el-select",
              {
                attrs: {
                  size: "small",
                  filterable: "",
                  disabled: !_vm.subminPaperData.orgId,
                  placeholder: _vm.$t("testControl.QXZLXJH"),
                },
                on: {
                  change: () => {
                    _vm.clearData("subminPaperData", "teamOrPlayer")
                    _vm.getTeamOrPlayer(
                      "getSubminPaperData",
                      _vm.subminPaperData.planId
                    )
                  },
                },
                model: {
                  value: _vm.subminPaperData.planId,
                  callback: function ($$v) {
                    _vm.$set(_vm.subminPaperData, "planId", $$v)
                  },
                  expression: "subminPaperData.planId",
                },
              },
              _vm._l(_vm.getSubminPaperData.planList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.planName, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.TDR"))),
        ]),
        _c(
          "span",
          [
            _c(
              "el-select",
              {
                attrs: {
                  size: "small",
                  filterable: "",
                  disabled: !_vm.subminPaperData.planId,
                  placeholder: _vm.$t("testControl.QXZTDR"),
                },
                model: {
                  value: _vm.subminPaperData.teamOrPlayer,
                  callback: function ($$v) {
                    _vm.$set(_vm.subminPaperData, "teamOrPlayer", $$v)
                  },
                  expression: "subminPaperData.teamOrPlayer",
                },
              },
              _vm._l(_vm.getSubminPaperData.teamOrPlayerList, function (item) {
                return _c("el-option", {
                  key: item.teamIdOrPlayerId,
                  attrs: {
                    label: item.teamNameOrPlayerName,
                    value: item.teamIdOrPlayerId,
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "item-form" },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                disabled: !_vm.subminPaperData.teamOrPlayer,
                type: "primary",
              },
              on: {
                click: () => {
                  _vm.handelClickButton(
                    "CHSubmitPaper",
                    _vm.subminPaperData.teamOrPlayer
                  )
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("testControl.CHSJ")))]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.XZJG"))),
        ]),
        _c(
          "span",
          [
            _c(
              "el-select",
              {
                attrs: {
                  size: "small",
                  filterable: "",
                  placeholder: _vm.$t("testControl.QXZJG"),
                },
                on: {
                  change: () => {
                    _vm.clearData("resetPaperData", "planId")
                    _vm.clearData("resetPaperData", "paperName")
                    _vm.getPlanList(
                      "getResetPaperData",
                      _vm.resetPaperData.orgId
                    )
                  },
                },
                model: {
                  value: _vm.resetPaperData.orgId,
                  callback: function ($$v) {
                    _vm.$set(_vm.resetPaperData, "orgId", $$v)
                  },
                  expression: "resetPaperData.orgId",
                },
              },
              _vm._l(_vm.orgList, function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.orgName, value: item.orgId },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.LXJH"))),
        ]),
        _c(
          "span",
          [
            _c(
              "el-select",
              {
                attrs: {
                  size: "small",
                  filterable: "",
                  disabled: !_vm.resetPaperData.orgId,
                  placeholder: _vm.$t("testControl.QXZLXJH"),
                },
                on: {
                  change: () => {
                    _vm.clearData("resetPaperData", "paperName")
                    _vm.getPaperData(
                      "resetPaperData",
                      _vm.resetPaperData.planId
                    )
                  },
                },
                model: {
                  value: _vm.resetPaperData.planId,
                  callback: function ($$v) {
                    _vm.$set(_vm.resetPaperData, "planId", $$v)
                  },
                  expression: "resetPaperData.planId",
                },
              },
              _vm._l(_vm.getResetPaperData.planList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.planName, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.XZSJ"))),
        ]),
        _c(
          "span",
          [
            _c("el-input", {
              attrs: {
                disabled: true,
                size: "small",
                filterable: "",
                placeholder: _vm.$t("testControl.DQWSJ"),
              },
              model: {
                value: _vm.resetPaperData.paperName,
                callback: function ($$v) {
                  _vm.$set(_vm.resetPaperData, "paperName", $$v)
                },
                expression: "resetPaperData.paperName",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "item-form" },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                disabled: !_vm.resetPaperData.paperName,
              },
              on: {
                click: () => {
                  _vm.handelClickButton("paperReset")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("testControl.CXBD")))]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.XZZY"))),
        ]),
        _c(
          "span",
          [
            _c(
              "el-select",
              {
                attrs: {
                  size: "small",
                  filterable: "",
                  placeholder: _vm.$t("testControl.XZZY"),
                },
                on: {
                  change: () => {
                    _vm.clearData("resetScoreData", "planId")
                    _vm.clearData("resetScoreData", "paperId")
                    _vm.clearData("resetScoreData", "orgId")
                    _vm.clearData("resetScoreData", "times")
                    _vm.getPaperList("getScoreData", _vm.resetScoreData.majorId)
                  },
                },
                model: {
                  value: _vm.resetScoreData.majorId,
                  callback: function ($$v) {
                    _vm.$set(_vm.resetScoreData, "majorId", $$v)
                  },
                  expression: "resetScoreData.majorId",
                },
              },
              _vm._l(_vm.majorList, function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.XZSJ"))),
        ]),
        _c(
          "span",
          [
            _c(
              "el-select",
              {
                attrs: {
                  size: "small",
                  filterable: "",
                  disabled: !_vm.resetScoreData.majorId,
                  placeholder: _vm.$t("testControl.XZSJ"),
                },
                on: {
                  change: () => {
                    _vm.clearData("resetScoreData", "orgId")
                    _vm.clearData("resetScoreData", "times")
                    _vm.clearData("resetScoreData", "planId")
                    _vm.getOrgList("getScoreData", _vm.resetScoreData.paperId)
                  },
                },
                model: {
                  value: _vm.resetScoreData.paperId,
                  callback: function ($$v) {
                    _vm.$set(_vm.resetScoreData, "paperId", $$v)
                  },
                  expression: "resetScoreData.paperId",
                },
              },
              _vm._l(_vm.getScoreData.paperList, function (item) {
                return _c("el-option", {
                  key: item.paperId,
                  attrs: { label: item.paperName, value: item.paperId },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.XZJG"))),
        ]),
        _c(
          "span",
          [
            _c(
              "el-select",
              {
                attrs: {
                  size: "small",
                  filterable: "",
                  disabled: !_vm.resetScoreData.paperId,
                  placeholder: _vm.$t("testControl.XZJG"),
                },
                on: {
                  change: () => {
                    _vm.setTimes()
                    _vm.clearData("resetScoreData", "planId")
                  },
                },
                model: {
                  value: _vm.resetScoreData.orgId,
                  callback: function ($$v) {
                    _vm.$set(_vm.resetScoreData, "orgId", $$v)
                  },
                  expression: "resetScoreData.orgId",
                },
              },
              _vm._l(_vm.getScoreData.orgList, function (item) {
                return _c("el-option", {
                  key: item.orgId,
                  attrs: { label: item.orgName, value: item.orgId },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.XZSJT"))),
        ]),
        _c(
          "span",
          [
            _c("el-date-picker", {
              attrs: {
                "picker-options": _vm.pickerOptions,
                type: "datetimerange",
                "value-format": "yyyy-MM-dd HH:mm:ss",
                disabled: !_vm.resetScoreData.orgId,
                size: "small",
                "range-separator": _vm.$t("testControl.Z"),
                "start-placeholder": _vm.$t("testControl.KSSJ"),
                "end-placeholder": _vm.$t("testControl.JSSJ"),
              },
              on: {
                change: () => {
                  _vm.handleDateChange()
                  _vm.clearData("resetScoreData", "planId")
                },
              },
              model: {
                value: _vm.resetScoreData.times,
                callback: function ($$v) {
                  _vm.$set(_vm.resetScoreData, "times", $$v)
                },
                expression: "resetScoreData.times",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "item-form" }, [
        _c("span", { staticClass: "title-lable" }, [
          _vm._v(_vm._s(_vm.$t("testControl.XZJH"))),
        ]),
        _c(
          "span",
          [
            _c(
              "el-select",
              {
                attrs: {
                  size: "small",
                  filterable: "",
                  disabled: _vm.resetScoreData.times
                    ? !_vm.resetScoreData.times.length
                    : !_vm.resetScoreData.times,
                  placeholder: _vm.$t("testControl.XZJH"),
                },
                model: {
                  value: _vm.resetScoreData.planId,
                  callback: function ($$v) {
                    _vm.$set(_vm.resetScoreData, "planId", $$v)
                  },
                  expression: "resetScoreData.planId",
                },
              },
              _vm._l(_vm.getScoreData.planList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.planName, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "item-form" },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                disabled:
                  !_vm.resetScoreData.times || _vm.getScoreData.planList
                    ? !_vm.getScoreData.planList.length
                    : !_vm.getScoreData.planList,
              },
              on: {
                click: () => {
                  _vm.handelClickButton("scoreReset")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("testControl.CXPF")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }